import React, { useState } from 'react';
import TermCondition from '../../utils/agreements/TermCondition/TermCondition';
import PrivacyPolice from '../../utils/agreements/PrivacyPolice/PrivacyPolice';

function AgreementModal({ onAccept }) {
  const [activeTab, setActiveTab] = useState('terms');
  const [isCheckedTerms, setIsCheckedTerms] = useState(false);
  const [isCheckedPrivacy, setIsCheckedPrivacy] = useState(false);

  const handleAccept = () => {
    if (isCheckedTerms && isCheckedPrivacy) {
      localStorage.setItem('papakilo_terms_accepted', 'true');
      
      // Simply call the onAccept callback
      onAccept();
    }
  };
  
  const handleCheckboxChange = () => {
    if (activeTab === 'terms') {
      setIsCheckedTerms(!isCheckedTerms);
    } else {
      setIsCheckedPrivacy(!isCheckedPrivacy);
    }
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-2xl rounded-xl shadow-2xl max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="bg-blue-600 text-white p-4 rounded-t-xl flex justify-between items-center">
          <h2 className="text-xl font-bold">
            {activeTab === 'terms' ? 'Syarat & Ketentuan' : 'Kebijakan Privasi'}
          </h2>
          <div className="flex space-x-2">
            <button
              onClick={() => setActiveTab('terms')}
              className={`px-3 py-1 rounded ${
                activeTab === 'terms' 
                  ? 'bg-blue-500 text-white' 
                  : 'bg-blue-400 text-blue-100'
              }`}
            >
              Syarat
            </button>
            <button
              onClick={() => setActiveTab('privacy')}
              className={`px-3 py-1 rounded ${
                activeTab === 'privacy' 
                  ? 'bg-blue-500 text-white' 
                  : 'bg-blue-400 text-blue-100'
              }`}
            >
              Privasi
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-4 overflow-y-auto flex-grow">
          {activeTab === 'terms' ? <TermCondition /> : <PrivacyPolice />}
        </div>

        {/* Checkbox */}
        <div className="p-4 border-t">
          <div className="flex items-center space-x-2 mb-4">
            <input 
              type="checkbox" 
              id="accept-check"
              checked={activeTab === 'terms' ? isCheckedTerms : isCheckedPrivacy}
              onChange={handleCheckboxChange}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            />
            <label 
              htmlFor="accept-check" 
              className="text-sm text-gray-700"
            >
              Saya telah membaca dan menyetujui {activeTab === 'terms' ? 'Syarat & Ketentuan' : 'Kebijakan Privasi'}
            </label>
          </div>

          <button
            onClick={handleAccept}
            disabled={!(isCheckedTerms && isCheckedPrivacy)}
            className={`w-full py-3 rounded-lg text-white font-bold ${
              isCheckedTerms && isCheckedPrivacy
                ? 'bg-blue-600 hover:bg-blue-700'
                : 'bg-gray-400 cursor-not-allowed'
            }`}
          >
            Lanjutkan ke Website
          </button>
        </div>
      </div>
    </div>
  );
}

export default AgreementModal;